import { NavigateFunction } from 'react-router-dom';
import { Button, Stack, Typography } from 'styles';
import { useTranslation } from 'utils/translations';

const ErrorPage: React.FC<{
	navigate?: NavigateFunction;
}> = ({ navigate }) => {
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: 'clientLabels',
	});

	return (
		<Stack
			height="100vh"
			alignItems="center"
			justifyContent="center"
			direction="column"
			gap="1rem"
		>
			<Typography variant="headline2">
				{tClientLabels('error.globalError')}
			</Typography>
			{!!navigate && (
				<Button onClick={() => navigate?.('/')} variant="contained">
					{tClientLabels('commons.buttons.returnToHome')}
				</Button>
			)}
		</Stack>
	);
};

export default ErrorPage;
